import axios from "axios";
import { getField, updateField } from "vuex-map-fields";
import i18n from "@/i18n";
import Vue from "vue";

export default {
  namespaced: true,
  state: {
    fetched: false,
    savingInProgress: false,
    messages: [],
  },
  getters: {
    getField, //vuex-map-fields
  },
  mutations: {
    updateField, //vuex-map-fields
  },
  actions: {
    store({ commit, state, dispatch }, payload) {
      updateField(state, { path: "savingInProgress", value: true });
      return axios
        .post(this._vm.$apiURL + `/customers/${payload.customer_id}/messages`,
          payload,
        )
        .then((response) => {
          this._vm.$inform(this._vm.i18n.t("common.success_add"));
          updateField(state, { path: "messages", value: response.data.messages });
        })
        .catch((error) => {
          dispatch("common/showError", { error: error }, { root: true });
        })
        .finally(() => {
          updateField(state, { path: "savingInProgress", value: false });
        });
    },
    async get({ commit, state, dispatch }, payload) {
      updateField(state, { path: "fetched", value: false });
      return await axios
        .get(this._vm.$apiURL + `/customers/${payload.customer_id}/messages`)
        .then((response) => {
          updateField(state, { path: "messages", value: response.data.data });
        })
        .catch((error) => {
          dispatch("common/showError", { error: error }, { root: true });
        })
        .finally(() => {
          updateField(state, { path: "fetched", value: true });
        });
    },
  },
};
